import ProfilePhone from '@/components/profile/phone';

export default ProfilePhone;
